/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:38
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Cap {
    /**
    * 获取数组字典列表
    */
    export var GetList = (data: any): Promise<any> => {
        return Get(`/msls/DataDictionary/GetList?${qs.stringify(data)}`, {});
    };
    /**
     * 获取数组字典列表
     */
    export var AddOrEditDicType = (data: any): Promise<any> => {
        return Post(`/msls/DataDictionary/Add`, data);
    };
    /**
     * 获取数组字典列表
     */
    export var EditOrEditDicType = (data: any): Promise<any> => {
        return Put(`/msls/DataDictionary/Edit/`+ data.id, data);
    };
    /**
     * 获取数组字典列表
     */
    export var DeleteDicName = (data: any): Promise<any> => {
        return Put(`/msls/DataDictionary/DeleteDicName/`+ data.id,'');
    };
}
